/**
 * This file contains logic that is specific to funding instrument selection
 */

import store from '../transfer/stores/configureStore'
import { WALLET } from '../transfer/constants'
import { isOpenBankingTreatment } from './openBanking'

export function generateFIFlowUrl({ flowType = 'send', ...data }) {
  return generateGenericFlowURL(
    { flowType, ...data },
    '/myaccount/transfer/flow/fi/new/?'
  )
}

export function generateNegBalFlowUrl({ flowType = 'send', ...data }) {
  return generateGenericFlowURL(
    { flowType, ...data },
    '/myaccount/transfer/flow/fi/neg/?'
  )
}

export function generateGenericFlowURL(
  { flowType = 'send', ...data },
  urlPrefix
) {
  const params = { flowType, ...data }
  const flowData = Object.keys(params)
    .reduce(
      (res, key) =>
        (res += `${encodeURIComponent(key)}=${encodeURIComponent(
          params[key]
        )}&`),
      ''
    )
    .slice(0, -1)
  return `${urlPrefix}${flowData}`
}

/**
 * Function to check eligibility of moneynodeweb add FI flow
 */
export function canAddBankAndCard() {
  const canAddFI = store.getState().server.groupFeatures
    .isMoneyNodeWebAddFISupported
  return canAddFI
}

/**
 * Function to check eligibility of moneynodeweb add bank only flow
 */
export function canOnlyAddBank(flowType) {
  const canAddBankOnly = store.getState().server.groupFeatures
    .isMoneyNodeWebAddBankOnlySupported
  return flowType === 'send' && canAddBankOnly
}

export function getFILinkName(flowType) {
  if (canAddBankAndCard()) {
    if (canOnlyAddBank(flowType)) {
      return WALLET.NEW_BANK
    }
    return WALLET.NEW_CARD
  }

  if (isOpenBankingTreatment()) {
    return WALLET.LINK_BANK_CARD
  }

  return WALLET.NEW_CARD
}
